<template>
  <div>
    <div v-if="this.loadpage == false" class="text-center">
      <b-spinner
        style="width: 5rem; height: 5rem;"
        variant="primary"
        label="Large Spinner"
      />
    </div>
    <div v-if="this.loadpage == true" class="pb-2" >
      <b-card>
        <b-row class="align-items-center">
          <b-col class="col-12 col-md-9 align-items-center">
            <div class="h5">
              <span>
                <b-img
                  :src="this.balance.balanceBaht >= 0 ? require('@/assets/status-list/baht-green.png') : require('@/assets/status-list/baht-red.png')"
                  width="48px"
                  height="48px"
                />
              </span>
              <span :class="this.balance.balanceBaht >= 0 ? 'text-success' : 'text-danger'">
                {{format_price(this.balance.balanceBaht)}} ฿
              </span>
            </div>
          </b-col>
          <b-col class="col-12 col-md-3 text-right d-none d-sm-block" >
            <b-button variant="outline-primary" v-b-modal.topup>เติม Balance</b-button>
          </b-col>
          <b-col class="col-12 col-md-3 text-right d-block d-sm-none" >
            <b-button variant="outline-primary" v-b-modal.topup block>เติม Balance</b-button>
          </b-col>
        </b-row>
      </b-card>
      <!-- pc -->
      <div class="d-none d-sm-block">
        <b-card no-body>
          <b-card-header>
            <div class="h5">รายการโอนเงินไปจีน</div>
            <b-button variant="primary" v-b-modal.add-transfer>สร้างรายการโอนเงิน</b-button>
          </b-card-header>
          <b-card-body class="d-flex py-0">
            <div class="d-flex align-items-center mb-1 ">
              <span class="px-0 col-1"> วันที่: </span>
              <flat-pickr v-model="startDate" class="form-control" :config="datePickerConfig"/>
              <span class="px-1"> - </span>
              <span class="px-0 col-1"> ถึงวันที่: </span>
              <flat-pickr v-model="endDate" class="form-control mr-1" :config="datePickerConfig"/>
              <b-button variant="primary" @click="getTransferHistory()">ค้นหา</b-button>
            </div>
          </b-card-body>
          <div v-if="this.loadHistory == false" class="text-center pt-2">
            <b-spinner
              style="width: 5rem; height: 5rem;"
              variant="primary"
              label="Large Spinner"
            />
          </div>
          <b-card-body v-if="this.loadHistory == true">
            <b-table
              responsive
              :items="transferList.data"
              :fields="transferFields"
              style="width:100%"
              outlined
              borderless
            >
              <template #cell(created)="data">
                {{formatDatetime(data.value)}}
              </template>
              <template #cell(amount)="data">
                {{format_price(data.value)}}
              </template>
              <template #cell(isDone)="data">
                <div v-if="data.value == true" class="text-success">สำเร็จ</div>
                <div v-else class="text-warning">รอทำรายการ</div>
              </template>
              <template #cell(rowId)="data">
                <feather-icon
                  :id="`view-${data.value}-transfer`"
                  icon="EyeIcon"
                  size="20"
                  class="cursor-pointer text-info mr-1"
                  @click="viewTransferInfo(data.item)"
                />
                <b-tooltip
                  title="รายละเอียด"
                  :target="`view-${data.value}-transfer`"
                  :delay="{show: '1500'}"
                />
                <feather-icon
                  v-if="data.item.isDone != true"
                  :id="`delete-${data.value}-transfer`"
                  icon="Trash2Icon"
                  size="20"
                  class="cursor-pointer text-danger"
                  @click="deleteTransfer(data.value)"
                />
                <b-tooltip
                  title="ลบ"
                  :target="`delete-${data.value}-transfer`"
                  :delay="{show: '1500'}"
                />
              </template>
            </b-table>
            <b-pagination
              v-model="currentPage"
              :total-rows="totalRows"
              :per-page="perPage"
              align="center"
              size="sm"
              class="my-0"
            />
          </b-card-body>
        </b-card>
        <b-card no-body>
          <b-card-header>
            <div class="h5">บัญชีที่ใช้ประจำ</div>
            <b-button variant="outline-primary" v-b-modal.bank-account>+ เพิ่มบัญชี</b-button>
          </b-card-header>
          <b-card-body>
            <b-table
              responsive
              :items="bankList"
              :fields="bankFields"
              style="width:100%"
              outlined
              borderless
              class="pt-1"
            >
              <template #cell(photolink)="data">
                <b-img class="px-0 cursor-pointer" width="50px" :src="data.value" @click="showImg(data.value)" fluid/>
              </template>
              <template #cell(rowId)="data">
                <feather-icon
                  :id="`edit-${data.value}-bank`"
                  icon="EditIcon"
                  size="20"
                  class="cursor-pointer text-warning mr-1"
                  @click="openEditBank(data.item)"
                />
                <b-tooltip
                  title="แก้ไข"
                  :target="`edit-${data.value}-bank`"
                  :delay="{show: '1500'}"
                />
                <feather-icon
                  :id="`delete-${data.value}-bank`"
                  icon="Trash2Icon"
                  size="20"
                  class="cursor-pointer text-danger"
                  @click="deleteBankAccount(data.value)"
                />
                <b-tooltip
                  title="ลบ"
                  :target="`delete-${data.value}-bank`"
                  :delay="{show: '1500'}"
                />
              </template>
            </b-table>
          </b-card-body>
        </b-card>
      </div>
      <!-- mobile -->
      <div class="d-block d-sm-none" >
        <b-card no-body>
          <b-card-body>
            <div class="pb-1">รายการโอนเงินไปจีน</div>
            <b-button variant="primary" block v-b-modal.add-transfer>สร้างรายการโอนเงิน</b-button>
            <div class="d-flex align-items-center pt-2">
              <span class="px-0 col-2"> วันที่: </span>
              <flat-pickr v-model="startDate" class="form-control" :config="datePickerConfig"/>
            </div>
            <div class="pt-1 d-flex align-items-center">
              <span class="px-0 col-2"> ถึงวันที่: </span>
              <flat-pickr v-model="endDate" class="form-control" :config="datePickerConfig"/>
            </div>
            <b-button class="mt-1 mb-n1" variant="primary" @click="getTransferHistory()">ค้นหา</b-button>
          </b-card-body>
        </b-card>
        <div v-if="this.loadHistory == false" class="text-center">
          <b-spinner
            style="width: 5rem; height: 5rem;"
            variant="primary"
            label="Large Spinner"
          />
        </div>
        <div v-if="this.loadHistory == true">
          <b-card v-for="item in transferList.data" :key="item.length" no-body>
            <b-card-header class="pb-0">
              <div>{{formatDatetime(item.created)}}</div>
              <div v-if="item.isDone == true" class="text-success">สำเร็จ</div>
              <div v-else class="text-warning">รอทำรายการ</div>
            </b-card-header>
            <b-card-body>
              <hr>
              <b-row>
                <b-col class="col-4 pr-0">บัญชีปลายทาง :</b-col>
                <b-col>
                  <div>{{item.transferToAccountName}}</div>
                  <div>{{item.transferToNumber}}</div>
                  <div>{{item.transferToBankName}}</div>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="col-4 pr-0">ยอด(หยวน) :</b-col>
                <b-col>
                  <div>{{format_price(item.amount)}}</div>
                </b-col>
              </b-row>
              <b-row>
                <b-col class="col-4 pr-0">หมายเหตุ :</b-col>
                <b-col>
                  <div>{{item.remark}}</div>
                </b-col>
              </b-row>
              <div class="pt-1">
                <b-button @click="viewTransferInfo(item)" variant="primary" block>รายละเอียด</b-button>
                <b-button v-if="item.isDone != true" @click="deleteTransfer(item.rowId)" variant="outline-danger" block>ลบ</b-button>
              </div>
            </b-card-body>
          </b-card>
        </div>
        <b-pagination
          v-model="currentPage"
          :total-rows="totalRows"
          :per-page="perPage"
          align="center"
          size="sm"
          class="mt-0"
        />
        <hr >
        <b-card>
          <div class="pb-1">บัญชีที่ใช้ประจำ</div>
          <b-button variant="outline-primary" block v-b-modal.bank-account>เพิ่มบัญชี</b-button>
        </b-card>
        <b-card v-for="item in bankList" :key="item.length" no-body>
          <b-card-header class="pb-0">
            {{item.accountName}}
          </b-card-header>
          <b-card-body>
            <hr>
            <b-row>
              <b-col class="col-4 pr-0">เลขบัญชี :</b-col>
              <b-col>{{item.accountNumber}}</b-col>
            </b-row>
            <b-row>
              <b-col class="col-4 pr-0">ธนาคาร :</b-col>
              <b-col>{{item.bankName}}</b-col>
            </b-row>
            <b-row>
              <b-col class="col-4 pr-0">รูป :</b-col>
              <b-col>
                <b-link v-if="item.photolink != null" @click="showImg(item.photolink)">คลิก</b-link>
              </b-col>
            </b-row>
            <b-row>
              <b-col class="col-4 pr-0">ข้อความช่วยจำ :</b-col>
              <b-col>{{item.remark}}</b-col>
            </b-row>
            <div class="pt-1">
              <b-button @click="openEditBank(item)" variant="warning" block>แก้ไข</b-button>
              <b-button @click="deleteBankAccount(item.rowId)" variant="outline-danger" block>ลบ</b-button>
            </div>
          </b-card-body>
        </b-card>
      </div>
    </div>

    <!-- add transfer -->
    <b-modal
      ref="add-transfer"
      id="add-transfer"
      header-class="align-items-center pb-0 pr-0"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="md"
    >
      <template v-slot:modal-header>
        <div>
          <h3>เพิ่มรายการโอนเงิน</h3>
        </div>
        <div>
          <b-button @click="closeAddTransfer" variant="flat-light" class="pt-0">
            <feather-icon
              icon="XIcon"
              size="20"
            />
          </b-button>
        </div>
      </template>
      <b-form>
        <b-row class="align-items-center pb-1">
          <b-col class="col-12 col-md-3">เลือกบัญชี :</b-col>
          <b-col>
            <div class="d-flex">
              <b-form-select
                v-model="chooseBank"
                class="form-control mr-1"
              >
                <b-form-select-option :value="null">--กรุณาเลือกรายการ--</b-form-select-option>
                <b-form-select-option v-for="item in bankList" :key="item.length" :value="item">
                 {{item.remark}} : {{item.accountName}} : {{item.accountNumber}} : {{item.bankName}}
                </b-form-select-option>
              </b-form-select>
              <b-button
                variant="outline-primary"
                class="btn-icon"
                v-b-modal.bank-account
              >
                <feather-icon icon="PlusIcon" />
              </b-button>
            </div>
            <small v-if="this.valChooseBank == false" class="text-danger">กรุณาเลือกบัญชีปลายทาง</small>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-12 col-md-3">ยอดโอน :</b-col>
          <b-col>
            <div class="d-flex align-items-center">
              <cleave
                v-model="amountYuan"
                :options="options.amount"
                class="form-control mr-1"
              />
              <span>หยวน</span>
            </div>
            <small v-if="this.valAmount == false" class="text-danger">กรุณากรอกจำนวนเงิน</small>
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-1">
          <b-col class="col-12 col-md-3">รูปภาพเพิ่มเติม :</b-col>
          <b-col>
            <b-form-file
              v-model="transferPhoto"
              placeholder="Choose a file"
              drop-placeholder="Drop file here..."
            />
          </b-col>
        </b-row>
        <b-row class="align-items-center pb-2">
          <b-col class="col-12 col-md-3">หมายเหตุ :</b-col>
          <b-col>
            <b-form-textarea v-model="remarkTransfer"/>
          </b-col>
        </b-row>
        <div>ยอดเงินที่ต้องใช้ : {{format_price(this.totalAmountBaht)}}</div>
        <h5 v-if="this.valBalance == false" class="text-center text-danger">ยอดเงินใน Balance ไม่พอ กรุณาเติมเงิน!</h5>
        <div class="pt-1 text-right">
          <b-button @click="addTransferYuan" variant="primary" :disabled="this.loadBtnTransfer == false || this.valBalance == false">
            <b-spinner v-if="this.loadBtnTransfer == false" small/>
            บันทึก
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- transfer info -->
    <b-modal
      ref="transfer-info"
      id="transfer-info"
      title="ข้อมูลการโอนเงิน"
      @hidden="closeTransferInfo"
      hide-footer
      no-close-on-backdrop
      size="md"
    >
      <b-form>
        <div v-if="this.loadInfo == false" class="text-center">
          <b-spinner
            style="width: 5rem; height: 5rem;"
            variant="primary"
            label="Large Spinner"
          />
        </div>
        <div v-if="this.loadInfo == true">
          <b-row>
            <b-col>{{formatDatetime(this.transferInfo.created)}}</b-col>
            <b-col class="text-right">
              <div v-if="this.transferInfo.isDone == true" class="text-success">สำเร็จ</div>
              <div v-if="this.transferInfo.isDone == false" class="text-warning">รอตรวจสอบ</div>
            </b-col>
          </b-row>
          <hr>
          <b-row>
            <b-col class="col-12 col-md-3 pr-0">บัญชีปลายทาง :</b-col>
            <b-col>
              <div>{{this.transferInfo.transferToAccountName}}</div>
              <div>{{this.transferInfo.transferToNumber}}</div>
              <div>{{this.transferInfo.transferToBankName}}</div>
            </b-col>
          </b-row>
          <b-row>
            <b-col class="col-4 col-md-3 pr-0">จำนวน(หยวน) :</b-col>
            <b-col>{{format_price(this.transferInfo.amount)}}</b-col>
          </b-row>
          <b-row>
            <b-col class="col-4 col-md-3 pr-0">เรท :</b-col>
            <b-col>{{format_price(this.transferInfo.rate)}}</b-col>
          </b-row>
          <b-row>
            <b-col class="col-4 col-md-3 pr-0">ค่าธรรมเนียม :</b-col>
            <b-col>{{format_price(this.transferInfo.fee)}}</b-col>
          </b-row>
          <b-row>
            <b-col class="col-4 col-md-3 pr-0">รวม(บาท) :</b-col>
            <b-col>{{format_price(this.transferInfoBaht)}}</b-col>
          </b-row>
          <div class="text-center pt-1">
            <b-img
              :src="this.transferInfo.transferToPhoto"
              width="200px"
              class="cursor-pointer"
              @click="showImg(transferInfo.transferToPhoto)"
            />
          </div>
          <div class="text-right pt-1">
            <b-button @click="closeTransferInfo" variant="primary">เรียบร้อย</b-button>
          </div>
        </div>
      </b-form>
    </b-modal>

    <!-- add bank account -->
    <b-modal
      ref="bank-account"
      id="bank-account"
      header-class="align-items-center pb-0 pr-0"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="md"
    >
      <template v-slot:modal-header>
        <div>
          <h3>เพิ่มบัญชีปลายทาง</h3>
        </div>
        <div>
          <b-button @click="closeBankAccount" variant="flat-light" class="pt-0">
            <feather-icon
              icon="XIcon"
              size="20"
            />
          </b-button>
        </div>
      </template>
      <b-form>
        <b-row>
          <b-col class="col-3 col-md-3 pr-0">ประเภท :</b-col>
          <b-col>
            <b-form-radio-group
              v-model="bankTypeSel"
              stacked
            >
              <div v-for="item in bankType" :key="item.length" class="pb-1">
                <b-form-radio :value="item">
                  {{item.text}}
                </b-form-radio>
              </div>
            </b-form-radio-group>
            <small v-if="this.valType == false" class="text-danger">กรุณาเลือกประเภท</small>
          </b-col>
        </b-row>
        <b-row class="pb-1">
          <b-col class="col-12 col-md-3 pr-0">ธนาคาร :</b-col>
          <b-col>
            <b-form-input v-model="bankName"/>
            <small v-if="this.valName == false" class="text-danger">กรุณากรอกชื่อธนาคาร</small>
          </b-col>
        </b-row>
        <b-row class="pb-1">
          <b-col class="col-12 col-md-3 pr-0">ชื่อบัญชี :</b-col>
          <b-col>
            <b-form-input v-model="bankAccountName"/>
            <small v-if="this.valAccountName == false" class="text-danger">กรุณากรอกชื่อบัญชีธนาคาร</small>
          </b-col>
        </b-row>
        <b-row class="pb-1">
          <b-col class="col-12 col-md-3 pr-0">เลขบัญชี :</b-col>
          <b-col>
            <b-form-input v-model="bankNumber"/>
            <small v-if="this.valNumber == false" class="text-danger">กรุณากรอกเลขบัญชีธนาคาร</small>
          </b-col>
        </b-row>
        <b-row class="pb-1">
          <b-col class="col-12 col-md-3 pr-0">ข้อความช่วยจำ :</b-col>
          <b-col><b-form-textarea v-model="bankRemark"/></b-col>
        </b-row>
        <b-row class="pb-2">
          <b-col class="col-12 col-md-3 pr-0">รูปภาพเพิ่มเติม :</b-col>
          <b-col>
            <b-form-file
              v-model="bankPhoto"
              placeholder="Choose a file"
              drop-placeholder="Drop file here..."
            />
          </b-col>
        </b-row>
        <div class="text-right">
          <b-button variant="primary" @click="addBankAccount" :disabled="this.loadBtnBank == false">
            <b-spinner v-if="this.loadBtnBank == false" small />
            บันทึก
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- edit bank account -->
    <b-modal
      ref="edit-bank"
      id="edit-bank"
      header-class="align-items-center pb-0 pr-0"
      hide-footer
      no-close-on-backdrop
      no-close-on-esc
      size="md"
    >
      <template v-slot:modal-header>
        <div>
          <h3>แก้ไขบัญชีปลายทาง</h3>
        </div>
        <div>
          <b-button @click="closeBankAccount" variant="flat-light" class="pt-0">
            <feather-icon
              icon="XIcon"
              size="20"
            />
          </b-button>
        </div>
      </template>
      <b-form>
        <b-row>
          <b-col class="col-3 col-md-3 pr-0">ประเภท :</b-col>
          <b-col>
            <b-form-radio-group
              v-model="bankTypeSel"
              stacked
            >
              <div v-for="item in bankType" :key="item.length" class="pb-1">
                <b-form-radio :value="item">
                  {{item.text}}
                </b-form-radio>
              </div>
            </b-form-radio-group>
            <small v-if="this.valType == false" class="text-danger">กรุณาเลือกประเภท</small>
          </b-col>
        </b-row>
        <b-row class="pb-1">
          <b-col class="col-12 col-md-3 pr-0">ธนาคาร :</b-col>
          <b-col>
            <b-form-input v-model="bankName"/>
            <small v-if="this.valName == false" class="text-danger">กรุณากรอกชื่อธนาคาร</small>
          </b-col>
        </b-row>
        <b-row class="pb-1">
          <b-col class="col-12 col-md-3 pr-0">ชื่อบัญชี :</b-col>
          <b-col>
            <b-form-input v-model="bankAccountName"/>
            <small v-if="this.valAccountName == false" class="text-danger">กรุณากรอกชื่อบัญชีธนาคาร</small>
          </b-col>
        </b-row>
        <b-row class="pb-1">
          <b-col class="col-12 col-md-3 pr-0">เลขบัญชี :</b-col>
          <b-col>
            <b-form-input v-model="bankNumber"/>
            <small v-if="this.valNumber == false" class="text-danger">กรุณากรอกเลขบัญชีธนาคาร</small>
          </b-col>
        </b-row>
        <b-row class="pb-1">
          <b-col class="col-12 col-md-3 pr-0">ข้อความช่วยจำ :</b-col>
          <b-col><b-form-textarea v-model="bankRemark"/></b-col>
        </b-row>
        <b-row class="pb-2">
          <b-col class="col-12 col-md-3 pr-0">รูปภาพเพิ่มเติม :</b-col>
          <b-col>
            <b-form-file
              v-model="bankPhoto"
              placeholder="Choose a file"
              drop-placeholder="Drop file here..."
            />
          </b-col>
        </b-row>
        <div class="text-right">
          <b-button variant="primary" @click="editBankAccount" :disabled="this.loadBtnBank == false">
            <b-spinner v-if="this.loadBtnBank == false" small />
            แก้ไข
          </b-button>
        </div>
      </b-form>
    </b-modal>

    <!-- topup balance -->
      <b-modal
        id="topup"
        ref="topup"
        @hidden="closeTopupBalance"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
      >
        <div class="text-center ">
          <h3 class="pb-1">กรุณาระบุจำนวนที่ต้องการเติม Balance</h3>
          <cleave
            v-model="amountBalance"
            :options="options.amount"
            class="form-control "
          />
          <small v-if="this.valAmount == false" class="text-danger">กรุณาระบุจำนวนเงิน</small>
        </div>
        <div class="pt-2">
          <b-button
            class="float-right"
            variant="primary"
            @click="TopupToPayment"
          >
            ดำเนินการต่อ >>
          </b-button>
          <b-button @click="closeTopupBalance" variant="outline-danger">ยกเลิก</b-button>
        </div>
      </b-modal>

      <b-modal
        ref="payment"
        id="payment"
        header-class="align-items-center pb-0 pr-0"
        hide-footer
        no-close-on-backdrop
        no-close-on-esc
        size="md"
      >
        <template v-slot:modal-header>
          <div><h3>เติม Balance</h3></div>
          <div>
            <b-button @click="closePay(1)" variant="flat-light">
              <feather-icon icon="XIcon" size="20"/>
            </b-button>
          </div>
        </template>
        <!-- step -->
        <div class="d-flex align-items-center pb-2 mt-n2">
          <div class="text-center mt-2">
            <b-avatar class="d-flex" variant="light-success" size="lg" text="1"/>
            <small>ช่องทาง<br>ชำระเงิน</small>
          </div>
          <hr style="border-top: 1px solid inset; flex-grow: 1;">
          <div class="text-center">
            <b-avatar class="d-flex" :variant="stepPay >= 1 ? 'light-success' : 'light-secondary'" size="lg" text="2"/>
              <small>ดำเนินการ</small>
          </div>
          <hr style="border-top: 1px solid inset; flex-grow: 1;">
          <div class="text-center">
            <b-avatar class="d-flex" :variant="stepPay == 2 ? 'light-success' : 'light-secondary'" size="lg" text="3"/>
            <small>สำเร็จ</small>
          </div>
        </div>

        <!-- body -->
        <div class="justify-content-md-center">
          <div v-if="stepPay == 0">
            <div>
              <h4 class="text-center">เลือกช่องทางการชำระเงิน</h4>
              <h5 class="text-center pb-1">ยอดชำระ {{format_price(this.amountReview)}} บาท</h5>
              <b-form-radio-group v-model="chooseMethod" stacked @change="clearVal">
                <div v-for="list in paymentMethod" :key="list.length" class="pb-1 d-flex align-items-center">
                  <b-form-radio :value="list.value" class="pr-1">{{list.text}}</b-form-radio>
                  <b-img
                    v-if="list.value == 1"
                    :src="require('@/assets/icon-for-payment/qr-icon.png')"
                    fluid
                    width="30px"
                    height="30px"
                  />
                  <b-img
                    v-if="list.value == 2"
                    :src="require('@/assets/icon-for-payment/visa-mastercard.png')"
                    width="70px"
                    height="70px"
                    fluid
                  />
                </div>
              </b-form-radio-group>
            </div>
            <div class="text-right">
              <b-button variant="primary" @click="nextStep(1)">ถัดไป>></b-button>
            </div>
          </div>
        </div>
        <div v-if="stepPay == 1">
          <div v-if="this.chooseMethod == 1">
            <div v-if="this.qrCode == null" class="text-center">
              <b-spinner
                style="width: 5rem; height: 5rem;"
                variant="primary"
                label="Large Spinner"
              />
            </div>
            <div v-if="this.qrCode != null">
              <h5 class="text-center pb-1">ยอดชำระ {{format_price(this.amountReview)}} บาท</h5>
              <b-img
                :src="`data:image/png;base64,${this.qrCode}`"
                fluid
                center
                class="pb-1"
              />
              <h5 v-if="this.countQrCode != null" class="text-center text-danger">
                ชำระเงินภายใน {{this.countQrCode}} วินาที
              </h5>
              <h5 v-if="this.countQrCode == null" class="text-center text-danger" @click="qrcodeAgain">
                <b-link>
                  ขอ QRCode อีกครั้ง
                </b-link>
              </h5>
              <div class="pb-1">
                <h5>*เมื่อแสกนชำระเรียบร้อยระบบจะอัพเดทยอดให้อัตโนมัติ</h5>
                <h5>
                  *หากชำระเรียบร้อยแล้วระบบไม่อัพเดทสถานะให้กรุณากดที่นี่ >> 
                  <b-button @click="checkStatusPayment" variant="primary" size="sm">เช็คสถานะการชำระเงิน</b-button>
                </h5>
              </div>
              <b-button variant="outline-danger" @click="backStep(0)"><<กลับ</b-button>
            </div>
          </div>
          <!-- credit/debit -->
          <div v-if="this.chooseMethod == 2">
            <h4 class="text-center">สรุปยอดชำระ</h4>
            <b-row class="px-lg-2">
              <b-col class="pr-0">ยอดที่ต้องการชำระ</b-col>
              <b-col class="text-right">{{format_price(this.amountPay)}} บาท</b-col>
            </b-row>
            <b-row class="px-lg-2">
              <b-col class="pr-0">ค่าธรรมเนียม</b-col>
              <b-col class="text-right">{{format_price(this.fee)}} บาท</b-col>
            </b-row>
            <b-row class="px-lg-2">
              <b-col class="pr-0">ยอดที่ต้องชำระทั้งหมด</b-col>
              <b-col class="text-right">{{format_price(this.amountPay + this.fee)}} บาท</b-col>
            </b-row>
            <div v-if="this.urlFlashpay == true">
              <div class="text-center text-danger py-1">กรุณาทำรายการที่หน้า FlashPay</div>
              <div>
                <div>*เมื่อชำระเรียบร้อยระบบจะอัพเดทยอดให้อัตโนมัติ</div>
                <div>
                  *หากชำระเรียบร้อยแล้วระบบไม่อัพเดทสถานะให้กรุณากดที่นี่ >> 
                  <b-button @click="checkStatusPayment" variant="primary" size="sm">เช็คสถานะการชำระเงิน</b-button>
                </div>
              </div>
            </div>
            <div class="pt-2">
              <b-button
                v-if="this.urlFlashpay == false"
                @click="reqPaymentCard()"
                class="float-right"
                variant="primary"
                :disabled="this.loadBtnCard == false"
              >
                <b-spinner v-if="this.loadBtnCard == false" small />
                ชำระเงิน
              </b-button>
              <b-button variant="outline-danger" @click="backStep(0)"><<กลับ</b-button>
            </div>
          </div>
          <div v-if="this.chooseMethod == 3">
            <b-form>
              <h5 class="text-center pb-1">ยอดชำระ {{format_price(this.amountReview)}} บาท</h5>
              <b-row>
                <b-col cols="12">
                  <b-form-group
                    class="font-weight-normal"
                    label="ธนาคาร :"
                    label-class="pt-0"
                    label-cols-md="3"
                  >
                    <b-form-radio-group v-model="chooseBankCompany" stacked>
                      <div v-for="list in bankCompany" :key="list.length">
                        <b-form-radio :value="list.bankId" class="pb-1">
                            <div class="d-flex">
                              <div class="pr-1">
                                <b-img
                                  :src="list.bankLogo"
                                  fluid
                                  width="30px"
                                  height="30px"
                                />
                              </div>
                              <div>
                                <div>ธนาคาร{{list.bankName}}</div>
                                <div>{{list.accountNumber}}</div>
                                <div>{{list.accountName}}</div>
                              </div>
                            </div>
                        </b-form-radio>
                      </div>
                    </b-form-radio-group>
                    <small v-if="this.checkBankId == false" class="text-danger">กรุณาเลือกบัญชีธนาคาร</small>
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    class="font-weight-normal"
                    label="วันที่ :"
                    label-cols-md="3"
                  >
                    <flat-pickr
                      v-model="payDate"
                      class="form-control"
                      :config="datePickerConfig"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    class="font-weight-normal"
                    label="เวลา :"
                    label-cols-md="3"
                  >
                    <flat-pickr
                      v-model="payTime"
                      class="form-control"
                      :config="{ enableTime: true, noCalendar: true, dateFormat: 'H:i', time_24hr: true}"
                    />
                  </b-form-group>
                </b-col>
                <b-col cols="12">
                  <b-form-group
                    class="font-weight-normal"
                    label="แนบสลิป :"
                    label-cols-md="3"
                  >
                    <b-form-file
                      v-model="slipPayment"
                      placeholder="Choose a file"
                      drop-placeholder="Drop file here..."
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-form>
            <div class="pt-2">
              <b-button
                class="float-right"
                variant="primary"
                @click="payToupupBalance"
                :disabled="this.loadBtntopup == false"
              >
                <b-spinner v-if="this.loadBtntopup == false" small />
                ชำระเงิน
              </b-button>
              <b-button variant="outline-danger" @click="backStep(0)"><<กลับ</b-button>
            </div>
          </div>
        </div>
        <div v-if="stepPay == 2">
          <div class="text-center pb-1">
            <b-avatar
              variant="light-success"
              size="100"
            >
              <feather-icon
                icon="CheckCircleIcon"
                size="70"
              />
            </b-avatar>
            <h1 class="pt-1">สำเร็จ</h1>
            <h3>ยอดชำระ {{this.chooseMethod == 2 ? format_price(this.amountPay + this.fee) : format_price(this.amountReview)}} บาท</h3>
          </div>
          <div class="text-right">
            <b-button @click="closePay(2)" variant="primary">
              ปิดหน้าต่าง ({{this.cd}})
            </b-button>
          </div>
        </div>
      </b-modal>

    <!-- show img -->
    <b-modal ref="show-img" hide-footer centered size="lg">
      <div class="text-center">
        <b-img class="px-0" :src="this.showImgInfo" fluid ></b-img>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {
  BRow, BCol, BButton, BCard, BCardHeader, BCardBody, BModal, VBToggle, BAvatar, BContainer, BLink, BTable,
  BSpinner, BImg, BFormCheckbox, BTooltip, BFormRadioGroup, BFormRadio, BFormGroup, BForm, BFormFile, BPagination,
  BFormSelect, BFormSelectOption, BFormTextarea, BFormInput,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import Cleave from 'vue-cleave-component'
import 'cleave.js/dist/addons/cleave-phone.us'
import flatPickr from 'vue-flatpickr-component'
import { format_price, formatDatetime, formatDate_eng, formatDate_engTime } from '@/views/global_function.js'
import axios from "axios";
import {header_token} from '@/views/token.js'
import {taobaoService_dotnet} from '@/views/global.js'
export default {
  name: 'Taobao2youTransfer',

  components: {
    BRow, BCol, BButton, BCard, BCardHeader, BCardBody, BModal, VBToggle, BImg, BSpinner, BTable, BPagination,
    BTooltip, BForm, BFormSelect, BFormSelectOption, BFormFile, BFormTextarea, BFormRadioGroup, BFormRadio,
    BFormInput, BLink, BAvatar, BFormGroup,

    Cleave,
    flatPickr,
   },

   directives: {
    'b-toggle': VBToggle,
  },

  data() {
    return {
      //add transfer yuan
      amountYuan: '',
      options: {
        amount: {
          numeral: true,
          numeralThousandsGroupStyle: 'thousand',
          numeralPositiveOnly: true,
        },
      },
      transferPhoto: null,
      remarkTransfer: '',
      totalAmountBaht: 0,
      chooseBank: null,
      valChooseBank: true,
      valAmount: true,
      valBalance: true,

      //view trnfers info
      transferInfo: [],
      transferInfoBaht: null,

      //transfer hitory
      startDate: null,
      endDate: null,

      transferList: [],
      transferFields: [
        { key: 'created', label: 'วันที่', thClass: 'text-center' },
        { key: 'transferToBankName', label: 'บัญชี', thClass: 'text-center' },
        { key: 'amount', label: 'ยอด', thClass: 'text-center', tdClass: 'text-right' },
        { key: 'remark', label: 'หมายเหตุ', thClass: 'text-center' },
        { key: 'isDone', label: 'สถานะ', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'rowId', label: 'ดำเนินการ', thClass: 'text-center', tdClass: 'text-center' },
      ],
      transferListMobile: [],

      //add bank account
      bankTypeSel: null,
      bankType: [
        { text: 'บัญชีธนาคาร', value: 1 },
        { text: 'Alipay', value: 2 },
        { text: 'Wechat', value: 3 },
      ],
      bankName: '',
      bankAccountName: '',
      bankNumber: '',
      bankRemark: '',
      bankPhoto: null,
      valType: true,
      valName: true,
      valAccountName: true,
      valNumber: true,

      // edit bank account
      isEdit: false,
      bankId: null,

      //bank account list
      bankList: [],
      bankFields: [
        { key: 'bankName', label: 'ธนาคาร', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'accountName', label: 'ชื่อบัญชี', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'accountNumber', label: 'เลขบัญชี', thClass: 'text-center' },
        { key: 'photolink', label: 'รูป', thClass: 'text-center', tdClass: 'text-center' },
        { key: 'remark', label: 'ข้อความช่วยจำ', thClass: 'text-center' },
        { key: 'rowId', label: 'ตัวดำเนินการ', thClass: 'text-center', tdClass: 'text-center' },
      ],

      //balance & rate
      balance: [],
      rate: [],

      //paging
      perPage: 10,
      currentPage: 1,
      totalRows: 1,

      // loading
      loadpage: true,
      loadInfo: true,
      loadBtnTransfer: true,
      loadBtnBank: true,
      loadHistory: true,

      //show img
      showImgInfo: null,

      // topup balance
      amountBalance: '',
      topupOrBill: null,
      amountReview: 0,
      valAmount: true,
      // flash pay
      stepPay: 0,
      chooseMethod: 1,
      paymentMethod: [
        { text: 'QR PAYMENT', value: 1 },
        { text: 'Credit Card/Debit Card', value: 2 },
        { text: 'โอนผ่านธนาคาร', value: 3 },
      ],
      qrCode: null,
      paymentIdCallback: [],
      fee: 0,
      amountPay: 0,
      //นับเวลา qrcode
      countQrCode: null,
      setCountQrCode: null,
      //เช็ค callback realtime
      countCallback: null,
      setCallback: null,
      //นับเวลาเสร็จสิ้น
      startCd: null,
      cd: null,

      //โอนเงินแบบเก่า
      userData: JSON.parse(localStorage.getItem('userData')),
      chooseBankCompany: null,
      bankCompany: [],
      slipPayment: null,
      checkBankId: true,
      payDate: new Date(),
      payTime: new Date().toLocaleString(undefined, {hour: '2-digit', hour12: false, minute:'2-digit'}),
      datePickerConfig: {
        altInput: true,
        altFormat: "d-m-Y",
      },
      loadBtntopup: true,
      loadBtnCard: true,
      urlFlashpay: false,

      dateId: new Date(new Date().getTime() + 7 * 60 * 60 * 1000).toISOString(),
    };
  },

  async created() {
    this.toFlashPay()
    this.loadpage = false
    await this.getRate()
    await this.getBalance()
    await this.getTransferHistory()
    await this.getBankAccount()
    this.getBankInfo()
    this.loadpage = true
  },

  watch: {
    async amountYuan() {
      if (this.amountYuan != '') {
        var yuan = Number(this.amountYuan.replace(/,/g, ""))
        if (await this.rate.transferRate == 0) {
          this.totalAmountBaht = yuan + this.rate.transferFee
        } else {
          this.totalAmountBaht = (yuan * this.rate.transferRate) + this.rate.transferFee
        }
        if (this.balance.balanceBaht < this.totalAmountBaht) {
          this.valBalance = false
        } else {
          this.valBalance = true
        }
      }
    },
    async bankTypeSel() {
      if (this.bankTypeSel) {
        if (this.bankTypeSel.value != 1) {
          this.isEdit = false
          this.bankName = this.bankTypeSel.text
        } else {
          if (this.isEdit == false) {
            this.bankName = ''
          }
        }
      }
    },
    async currentPage() {
      this.loadHistory = false
      await this.getTransferHistory()
      this.loadHistory = true
    }
  },

  methods: {
    format_price,
    formatDatetime,
    formatDate_eng,
    formatDate_engTime,
    async getRate() {
      let response = await axios.post(
        taobaoService_dotnet + 'api/General/get-exchange-rate',
        { headers: header_token }
      );
      this.rate = response.data
    },
    async getBalance() {
      let response = await axios.get(
        taobaoService_dotnet + 'app/Balance/get-customer-balance?LoginToken=' + this.userData.data.customerInfo.loginToken,
        { headers: header_token }
      );
      this.balance = response.data
    },
    async getBankInfo() {
      let response = await axios.get(
        taobaoService_dotnet + 'app/Payment/get-thai-bank-info',
        { headers: header_token }
      );
      this.bankCompany = response.data
    },
    //transfer
    async addTransferYuan() {
      if (this.chooseBank == null) {
        this.valChooseBank = false
      } else if (this.amountYuan == '' || this.amountYuan == '0') {
        this.valAmount = false
      } else {
        this.loadBtnTransfer = false
        var imgLink = ''
        if (this.transferPhoto) {
          imgLink = await this.getLinkPhoto(this.transferPhoto)
        }
        let response = await axios.post(
          taobaoService_dotnet + 'Transfer-yuan/create-transfer-yuan',
          // 'https://localhost:5001/Transfer-yuan/create-transfer-yuan',
          {
            "customerID": JSON.parse(localStorage.getItem('cusId')),
            "amount": Number(this.amountYuan.replace(/,/g, "")),
            "rate": this.rate.transferRate,
            "fee": this.rate.transferFee,
            "remark": this.remarkTransfer,
            "bankName": this.chooseBank.bankName,
            "accountName": this.chooseBank.accountName,
            "accountNumber": this.chooseBank.accountNumber,
            "photo": imgLink
          },
          { headers: header_token }
        );
        if (response.data.message == 'success') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'สร้างรายการโอนเงินเรียบร้อย',
              variant: 'success',
            },
          },
          { position: 'top-center' })
          this.closeAddTransfer()
          this.getTransferHistory()
        }
        this.loadBtnTransfer = true
      }
    },
    async getTransferHistory() {
      var skip = 0
      skip = (this.currentPage - 1) * 10
      let response = await axios.post(
        taobaoService_dotnet + 'Transfer-yuan/transfer-yuan-history',
        // 'https://localhost:5001/Transfer-yuan/transfer-yuan-history',
        {
          "customerID": JSON.parse(localStorage.getItem('cusId')),
          "startDate": this.startDate == null ? '' : this.startDate,
          "endDate": this.endDate == null ? '' : this.endDate,
          "skip": skip,
          "take": 10,
          "isDescending": true
        },
        { headers: header_token }
      );
      this.transferList = response.data
      this.totalRows = response.data.totalRows
      this.startDate = response.data.startDate
      this.endDate = response.data.endDate
    },
    async viewTransferInfo(item) {
      this.$refs['transfer-info'].show()
      this.transferInfo = await item
      if (this.transferInfo.rate == 0) {
        this.transferInfoBaht = this.transferInfo.amount + this.transferInfo.fee
      } else {
        this.transferInfoBaht = (this.transferInfo.amount * this.transferInfo.rate)  + this.transferInfo.fee
      }
    },
    async deleteTransfer(id) {
      this.$swal({
        title: 'ลบรายการโอนเงิน ?',
        text: "คุณแน่ใจหรือป่าวว่าต้องการลบรายการโอน ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          let response = await axios.post(
            taobaoService_dotnet + 'Transfer-yuan/delete-transfer-yuan',
            // 'https://localhost:5001/Transfer-yuan/delete-transfer-yuan',
            { "rowID": id },
            { headers: header_token }
          );
          if (response.data.message == 'success') {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'สำเร็จ',
                icon: 'CheckIcon',
                text: 'ลบรายการโอนเงินเรียบร้อย',
                variant: 'success',
              },
            },
            { position: 'top-center' })
            this.getTransferHistory()
          }
        }
      })
    },
    //bank account
    async addBankAccount() {
      if (this.bankTypeSel == null) {
        this.valType = false
      } else if (this.bankName == '') {
        this.valName = false
      } else if (this.bankAccountName == '') {
        this.valAccountName = false
      } else if (this.bankNumber == '') {
        this.valNumber = false
      } else {
        this.loadBtnBank = false
        var imgLink = ''
        if (this.bankPhoto) {
          imgLink = await this.getLinkPhoto(this.bankPhoto)
        }
        let response = await axios.post(
          taobaoService_dotnet + 'Transfer-yuan/add-bank-account',
          // 'https://localhost:5001/Transfer-yuan/add-bank-account',
          {
            "customerID": JSON.parse(localStorage.getItem('cusId')),
            "bankName": this.bankName,
            "accountName": this.bankAccountName,
            "accountNumber": this.bankNumber,
            "remark":this.bankRemark,
            "photo": imgLink
          },
          { headers: header_token }
        );
        if (response.data.message == 'success') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'เพิ่มบัญชีธนาคารเรียบร้อย',
              variant: 'success',
            },
          },
          { position: 'top-center' })
          this.closeBankAccount()
          this.getBankAccount()
        }
        this.loadBtnBank = true
      }
    },
    async getBankAccount() {
      let response = await axios.post(
        taobaoService_dotnet + 'Transfer-yuan/get-bank-account-list',
        // 'https://localhost:5001/Transfer-yuan/get-bank-account-list',
        {
          "customerID": JSON.parse(localStorage.getItem('cusId'))
        },
        { headers: header_token }
      );
      this.bankList = response.data
    },
    async openEditBank(item) {
      this.$refs['edit-bank'].show()
      this.bankId = item.rowId
      this.isEdit = true
      this.bankType.forEach((e) => {
        if (e.text == item.bankName) {
          this.bankTypeSel = e
        } else if (this.bankTypeSel == null) {
          this.bankTypeSel = this.bankType[0]
        }
      });
      this.bankName = item.bankName
      this.bankAccountName = item.accountName
      this.bankNumber = item.accountNumber
      this.bankRemark = item.remark
    },
    async editBankAccount() {
      if (this.bankTypeSel == null) {
        this.valType = false
      } else if (this.bankName == '') {
        this.valName = false
      } else if (this.bankAccountName == '') {
        this.valAccountName = false
      } else if (this.bankNumber == '') {
        this.valNumber = false
      } else {
        this.loadBtnBank = false
        var imgLink = null
        if (this.bankPhoto) {
          imgLink = await this.getLinkPhoto(this.bankPhoto)
        }
        let response = await axios.post(
          taobaoService_dotnet + 'Transfer-yuan/edit-bank-account',
          // 'https://localhost:5001/Transfer-yuan/edit-bank-account',
          {
            "rowID": this.bankId,
            "customerID": JSON.parse(localStorage.getItem('cusId')),
            "bankName": this.bankName,
            "accountName": this.bankAccountName,
            "accountNumber": this.bankNumber,
            "remark":this.bankRemark,
            "photo": imgLink
          },
          { headers: header_token }
        );
        if (response.data.message == 'success') {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'แก้ไขบัญชีธนาคารเรียบร้อย',
              variant: 'success',
            },
          },
          { position: 'top-center' })
          this.closeBankAccount()
          this.getBankAccount()
        }
        this.loadBtnBank = true
      }
    },
    async deleteBankAccount(id) {
      this.$swal({
        title: 'ลบบัญชีธนาคาร ?',
        text: "คุณแน่ใจหรือป่าวว่าต้องการลบบัญชีธนาคารนี้ ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          let response = await axios.post(
            taobaoService_dotnet + 'Transfer-yuan/delete-bank-account',
            // 'https://localhost:5001/Transfer-yuan/delete-bank-account',
            { "rowID": id },
            { headers: header_token }
          );
          if (response.data.message == 'success') {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: 'สำเร็จ',
                icon: 'CheckIcon',
                text: 'ลบบัญชีธนาคารเรียบร้อย',
                variant: 'success',
              },
            },
            { position: 'top-center' })
            this.getBankAccount()
          }
        }
      })
    },
    //get photo url
    async getLinkPhoto(img) {
      var imgLink = ''
      var FormData = require('form-data');
      var data = new FormData();
      data.append('', img);
      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'api/General/upload-file-with-type?UploadType=8',
        headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
          'Content-Type': 'application/json',
        },
        data : data
      };
      await axios(config)
      .then(function (response) {
        imgLink = response.data[0]
      })
      .catch(function (error) {
        console.log(error);
      });
      return imgLink
    },
    closeAddTransfer() {
      this.amountYuan = ''
      this.transferPhoto = null
      this.remarkTransfer = ''
      this.totalAmountBaht = 0
      this.valBalance = true
      this.$refs['add-transfer'].hide()
    },
    closeTransferInfo() {
      this.transferInfo = []
      this.transferInfoBaht = null
      this.$refs['transfer-info'].hide()
    },
    closeBankAccount() {
      this.bankTypeSel = null
      this.bankName = ''
      this.bankAccountName = ''
      this.bankNumber = ''
      this.bankRemark = ''
      this.bankPhoto = null
      this.isEdit = false
      this.bankId = null
      this.valType = true
      this.valName = true
      this.valAccountName = true
      this.valNumber = true

      this.$refs['bank-account'].hide()
      this.$refs['edit-bank'].hide()
    },

    //เติม balance
    nextStep(count) {
      this.stepPay = count
      this.reqPayment()
    },
    backStep(count) {
      this.$swal({
        title: 'เลือกช่องทางชำระเงินใหม่ ?',
        text: "คุณแน่ใจหรือป่าวว่าต้องการเลือกช่องทางชำระเงินใหม่ ?",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonText: 'OK',
        customClass: {
          confirmButton: 'btn btn-primary',
          cancelButton: 'btn btn-outline-danger ml-1',
        },
        buttonsStyling: false,
      }).then( async result => {
        if (result.value) {
          this.stepPay = count
          this.chooseBank = null
          this.checkBankId = true
          this.slipPayment = null
          // this.loadBtntopup = true
          clearInterval(this.interval);
          // clearInterval(this.startCd);
        }
      })
    },
    async TopupToPayment(){
      if(this.amountBalance == '' || this.amountBalance == '0'){
        this.valAmount = false
      } else {
        this.amountReview = Number(this.amountBalance.replace(/,/g, ""))
        this.$refs['payment'].show()
        this.valAmount = true
        this.$refs['topup'].hide()
      }
    },
    //payment qr & card
    async reqPayment() {
      //qr code
      if (this.chooseMethod == 1) {
        let responseReq = await axios.post(
          taobaoService_dotnet + 'app/FlashPay/flashpay-create-payment',

          {
            "customerID": JSON.parse(localStorage.getItem('cusId')),
            "amount": this.amountReview,
            "description": 'เติมเงินเข้า Balance',
            "PaymentId": [],
            "IsCard": false
          },
          { headers: header_token }
        );
        if (responseReq.data.message == 'success') {
          var keepdata = []
          var config = {
            method: 'post',
            url: taobaoService_dotnet + 'app/FlashPay/flashpay-create-order-pc?paymentOrderId=' + responseReq.data.paymentId,
            headers: {
            'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
            'Content-Type': 'application/json'
            },
          };
          await axios(config)
          .then(function (response) { keepdata = response.data })
          .catch(function (error) { console.log(error) })

          this.paymentIdCallback = await keepdata.outTradeNo.split("_")
          this.qrCode = keepdata.qrImage;
          if (keepdata.message == "Request Succeeded") {
            this.startQr()
            this.checkCallback(75)
          }
        }
      }
      // credit/debit
      else if (this.chooseMethod == 2) {
        this.amountPay = this.amountReview
        this.fee = Number(this.amountReview * 0.028)
      }
    },
    async reqPaymentCard() {
      this.loadBtnCard = false
      this.urlFlashpay = false
      let responseReq = await axios.post(
        taobaoService_dotnet + 'app/FlashPay/flashpay-create-payment',

        {
          "customerID": JSON.parse(localStorage.getItem('cusId')),
          "amount": this.amountReview,
          "description": 'เติมเงินเข้า Balance',
          "PaymentId": [],
          "IsCard": true
        },
        { headers: header_token }
      );
      if (responseReq.data.message == 'success') {
        var keepdata = []

        var config = {
          method: 'post',
          url: taobaoService_dotnet + 'app/FlashPay/flashpay-create-card?paymentOrderId=' + responseReq.data.paymentId,
          headers: {
          'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
          'Content-Type': 'application/json'
          },
        };
        await axios(config)
        .then(function (response) { keepdata = response.data })
        .catch(function (error) { console.log(error) })

        this.paymentIdCallback = keepdata.outTradeNo.split("_")
        if (keepdata.message == "Request Succeeded") {
          var url = window.location.href
          this.urlFlashpay = true
          window.open(url+'?urlFlahpay='+keepdata.redirectUrl)
          this.checkCallback(650)
        }
      }
      this.loadBtnCard = true
    },
    toFlashPay() {
      const queryString = window.location.search;
      const urlParams = new URLSearchParams(queryString);
      const urlFP = urlParams.get('urlFlahpay')
      if (urlFP) {
        window.location.replace(urlFP, "_self")
      }
    },
    //ขอ qr code อีกครั้ง
    async qrcodeAgain() {
      let responseReq = await axios.post(
          taobaoService_dotnet + 'app/FlashPay/flashpay-create-payment',

          {
            "customerID": JSON.parse(localStorage.getItem('cusId')),
            "amount": this.amountReview,
            "description": 'เติมเงินเข้า Balance',
            "PaymentId": [],
            "IsCard": false
          },
          { headers: header_token }
        );
        if (responseReq.data.message == 'success') {
          var keepdata = []
          var config = {
            method: 'post',
            url: taobaoService_dotnet + 'app/FlashPay/flashpay-create-order-pc?paymentOrderId=' + responseReq.data.paymentId,
            headers: {
            'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
            'Content-Type': 'application/json'
            },
          };
          await axios(config)
          .then(function (response) { keepdata = response.data })
          .catch(function (error) { console.log(error) })

          this.paymentIdCallback = await keepdata.outTradeNo.split("_")
          this.qrCode = keepdata.qrImage;
          if (keepdata.message == "Request Succeeded") {
            this.startQr()
            this.checkCallback(75)
          }
        }
    },
    async payToupupBalance() {
      if (this.chooseMethod == 3 && this.chooseBankCompany == null) {
        this.checkBankId = false
      } else {
        this.loadBtntopup = false
        var datetime = ''
        var time12 = this.payTime.split(":")
        var imgLink = null
        if ( this.payDate.length == 10 ) {
          if (time12[0] == '24') {
            datetime = formatDate_eng(this.payDate) + ' ' + '00:' + time12[1]
          } else {
            datetime = formatDate_eng(this.payDate) + ' ' + this.payTime
          }
        } else  {
          if (time12[0] == '24') {
            datetime = formatDate_eng(this.payDate.toISOString().slice(0, 10)) + ' ' + '00:' + time12[1]
          } else {
            datetime = formatDate_eng(this.payDate.toISOString().slice(0, 10)) + ' ' + this.payTime
          }
        }
        if (this.slipPayment != null) {
          imgLink = await this.getLinkPhoto(this.slipPayment)
        }
        let response = await axios.post(
          taobaoService_dotnet + 'app/Payment/new-payment',
          {
            "amount": Number(this.amountReview.toFixed(2)),
            "bankID": this.chooseBankCompany,
            "loginToken": this.userData.data.customerInfo.loginToken,
            "photoLink": imgLink,
            "paymentIDList": [],
            "paymentDate": datetime
          },
          { headers: header_token }
        );
        if (response.data.status == "success"){
          clearInterval(this.setCallback);
          this.countCallback = null
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'แจ้งชำระเงินเรียบร้อย',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          this.stepPay = 2
          this.startCooldown()
        }
        this.loadBtntopup = true
      }
    },
    async checkStatusPayment() {
      var paymentId = this.paymentIdCallback[0] +'_' + this.paymentIdCallback[1]
      var keepdata = []
      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/FlashPay/callback-status-flashpay?paymentOrderId=' + paymentId,
        headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
        'Content-Type': 'application/json'
        },
      };
      await axios(config)
      .then(function (response) { keepdata = response.data })
      .catch(function (error) { console.log(error) })

      if (keepdata.tradeStatus == 3) {
        clearInterval(this.setCallback);
        this.countCallback = null
        this.$toast({
          component: ToastificationContent,
          props: {
            title: 'สำเร็จ',
            icon: 'CheckIcon',
            text: 'แจ้งชำระเงินเรียบร้อย',
            variant: 'success',
          },
        },
        {
          position: 'top-center',
        })
        this.stepPay = 2
        this.startCooldown()
      }
    },
    //เช็ค callback จาก flashpay
    checkCallback(count) {
      this.countCallback = count;
      this.setCallback = setInterval(this.checkStatusCallback, 1000);
    },
    async checkStatusCallback() {
      this.countCallback--;

      var keepdata = []
      var config = {
        method: 'post',
        url: taobaoService_dotnet + 'app/FlashPay/callback-status?paymentId=' + parseInt(this.paymentIdCallback[0]),
        headers: {
        'Authorization': 'Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJzdWIiOiIwIiwibmFtZSI6InRhb2JhbzJ5b3UiLCJyb2xlIjoiYWRtaW4iLCJjdXN0b21lcmlkIjoiIiwiZXhwIjoxNjI2MTAyNzgwLCJpc3MiOiJ0YW9iYW8yeW91IiwiYXVkIjoiaHR0cHM6Ly93d3cudGFvYmFvMnlvdS5jb20ifQ.gIhTvIMLXxpq6bUFPbp242szDgPRl33SaF3k5f6T3-U', 
        'Content-Type': 'application/json'
        },
      };
      await axios(config)
      .then(function (response) { keepdata = response.data })
      .catch(function (error) { console.log(error) })

      if (this.countCallback == 0) {
        clearInterval(this.setCallback);
      }
      if (keepdata.message == "success"){
        clearInterval(this.setCallback);
        this.countCallback = null
        if (keepdata.message == "success") {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'สำเร็จ',
              icon: 'CheckIcon',
              text: 'แจ้งชำระเงินเรียบร้อย',
              variant: 'success',
            },
          },
          {
            position: 'top-center',
          })
          this.stepPay = 2
          this.startCooldown()
        }
      }
    },
    startQr() {
      this.countQrCode = 60;
      this.setCountQrCode = setInterval(this.countQr, 1000);
    },
    countQr() {
      this.countQrCode--;
      if (this.countQrCode == 0){
        clearInterval(this.setCountQrCode);
        this.countQrCode = null
      }
    },
    //ตัวนับเวลาเสร็จสิ้น
    startCooldown() {
      this.cd = 5;
      this.startCd = setInterval(this.cooldown, 1000);
    },
    async cooldown() {
      this.cd--;
      if (this.cd == 0){
        clearInterval(this.startCd);
        this.cd = null
        await this.$router.push({path: '/'})
        this.$router.push({path: '/finance/payment-transfer-yuan'})
      }
    },

    closeTopupBalance() {
      this.amountBalance = ''
      this.valAmount = true
      this.$refs['topup'].hide()
    },
    async closePay(id) {
      if (id == 1) {
        this.$swal({
          title: 'ปิดหน้าต่างชำระเงิน ?',
          text: "คุณแน่ใจหรือป่าวว่าต้องการปิดหน้าต่างชำระเงิน ?",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonText: 'OK',
          customClass: {
            confirmButton: 'btn btn-primary',
            cancelButton: 'btn btn-outline-danger ml-1',
          },
          buttonsStyling: false,
        }).then( async result => {
          if (result.value) {
            this.stepPay = 0
            this.qrCode = null
            this.amountBalance = ''
            this.chooseMethod = 1
            this.chooseBankCompany = null
            this.checkBankId = true
            this.slipPayment = null
            clearInterval(this.setCallback);
            clearInterval(this.setCountQrCode);
            clearInterval(this.startCd);
            this.$refs['payment'].hide()
          }
        })
      } else if (id == 2) {
        clearInterval(this.setCallback);
        clearInterval(this.setCountQrCode);
        clearInterval(this.startCd);
        this.$refs['payment'].hide()
        await this.$router.push({path: '/'})
        this.$router.push({path: '/finance/payment'})
      }
    },
    clearVal() {
      this.stepPay = 0
      this.qrCode = null
    },

    //show image
    async showImg(img) {
      this.showImgInfo = await img
      this.$refs['show-img'].show()
    },
  },
};
</script>
<style lang="scss">
@import '@core/scss/vue/libs/vue-flatpicker.scss';
</style>